<template>
    <q-stepper-navigation class="justify-center group">
        <v-button v-if="currentStep != 'first'"
                  rounded outline no-caps
                  icon="arrow back"
                  class="no-shadow"
                  @click.prevent="$emit('previous')"
                  :label="$T('previous')"></v-button>

        <slot></slot>

        <v-button v-if="currentStep != 'last'"
                  rounded outline no-caps
                  icon-right="arrow forward"
                  class="no-shadow"
                  @click.prevent="$emit('next')"
                  :label="$T('next')"></v-button>
    </q-stepper-navigation>
</template>
<script>
    import {
        QStepperNavigation
    } from 'quasar-framework'

    export default {
        name: 'steps',

        props: ['currentStep'],
        components: {
            QStepperNavigation
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Steps.vue